import styled, { css } from 'styled-components';

export const WrapperSkeletonListDesktop = styled.div<{
  borderBottom?: boolean;
  marginBottom?: boolean;
}>`
  ${({ theme, borderBottom }) => css`
    width: 100%;
    padding: ${theme.spacing.km4} 0px;
    line-height: ${theme.font.size.m3};
    .grid-container.sc-fuel-grid-container-h {
      margin: ${theme.spacing.km0};
      align-items: center;
    }
    ${borderBottom &&
    css`
      border-bottom: 1px solid ${theme.color.border.neutral.default};
    `}
  `};
`;

export const WrapperSkeletonListMobile = styled.div`
  ${({ theme }) => css`
    .grid-container.sc-fuel-grid-container-h {
      align-items: center;
      padding: ${theme.spacing.km4} ${theme.spacing.km2} ${theme.spacing.km4}
        ${theme.spacing.km2};
      margin: ${theme.spacing.km0};
    }
  `}
`;

export const WrapperList = styled.div`
  width: 100%;
`;

export const ItemDesktop = styled.div`
  ${({ theme }) => css`
    display: grid;
    row-gap: ${theme.padding.km3};
  `}
`;

export const ColumnOneDesktop = styled.div`
  ${({ theme }) => css`
    ${WrapperList} {
      max-width: 348px;
      display: grid;
      grid-template-columns: 40px 1fr;
      gap: ${theme.padding.km2};
      align-items: center;
    }
  `}
`;
export const ColumnTwoDesktop = styled.div`
  ${({ theme }) => css`
    ${WrapperList} {
      max-width: 400px;
      display: grid;
      grid-area: columnTwo;
      grid-template-columns: 8px 1fr;
      gap: ${theme.padding.km2};
      min-height: 58px;
    }
  `}
`;

export const WrapperTruckerInfoMobile = styled.div`
  ${({ theme }) => css`
    ${WrapperList} {
      max-width: 348px;
      display: grid;
      grid-template-columns: 40px 1fr;
      gap: ${theme.padding.km2};
    }
  `}
`;

export const WrapperOriginAndDestinationMobile = styled.div`
  ${({ theme }) => css`
    ${WrapperList} {
      max-width: 400px;
      display: grid;
      grid-area: columnTwo;
      grid-template-columns: 8px 1fr;
      gap: ${theme.padding.km2};
      min-height: 58px;
    }
  `}
`;

export const ItemMobile = styled.div`
  ${({ theme }) => css`
    display: grid;
    row-gap: ${theme.padding.km2};
  `}
`;
